import PropTypes from 'prop-types'

export const PieLegendPropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  value: PropTypes.any,
  icon: PropTypes.string,
})
